import React, { useEffect }  from 'react';
import styled from 'styled-components';
import { useLocation, useParams } from 'react-router-dom';
import { useState } from 'react';
import { paramsToObject } from '../Functions/Helpers';
import { GetDataPromise } from '../Functions/SendingData';
import { apiMain } from '../../App';
import { LoadingFull } from '../LoadingFull';
import AgencyCart from './SmallComps/AgencyCart';
import TourCart from './SmallComps/TourCart';
import TourFilter from './SmallComps/TourFilter';
import TourCartBig from './SmallComps/TourCartBig';
import { Dictionery } from '../../Data/Dictionery';
import { setReachDataType } from '../Functions/SetHeaders';
const Styles = styled.div`
  width: calc(100% - calc(var(--universal-pad) * 2));
  margin: 0 var(--universal-pad) 1rem;
  display: grid;
  grid-template-columns: 270px repeat(1, 1fr);
  gap: 1rem;
  .items {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: min-content;
  }
  @media screen and (max-width: 850px) {
    grid-template-columns: repeat(1, 1fr);
  }
`
export default function TourList17 (props){
  const {data: dataRaw, lan, agency, dataMain} = props;
  const data = JSON.parse(dataRaw);
  const location = useLocation();
  const locParams = useParams();
  const [baseSearch, setBaseSearch] = useState(location.search)
  const [pageData, setPageData] = useState([]);
  const [loading, setLoading] = useState(false);
  const paramsBase = new URLSearchParams(baseSearch);
  const params = paramsToObject(paramsBase);
  useEffect(() => {
    if(location.search !== baseSearch){
      setBaseSearch(location.search);
    }
  }, [location.search])
  
  useEffect(() => {
    getData()
  }, []);
  useEffect(() => {
    getData()
  }, [baseSearch]);

  const getData = async(force = false) => {
    setLoading(true);
    let URLparams = new URLSearchParams();
    if(Object.keys(data).length){
      let keys = Object.keys(data);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        URLparams.append(key, data[key])
      }
    }
    if(dataMain){
      if(dataMain.Continent && Object.keys(dataMain.Continent).length && dataMain.Continent.Continent_Url === locParams.continent){
        URLparams.delete("Continent_Id")
        URLparams.append("Continent_Id", dataMain.Continent.Continent_Id)
      }
      if(dataMain.Country && Object.keys(dataMain.Country).length && dataMain.Country.Country_Url === locParams.country){
        URLparams.delete("Country_Id")
        URLparams.append("Country_Id", dataMain.Country.Country_Id)
      }
    }
    if(params){
      let keys = Object.keys(params);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        URLparams.append(key, params[key])
      }
    }
    URLparams.append("Tour_Type_Id", 1);
    let res = await GetDataPromise(`${apiMain}/api/v1/tourists/tour/tour_report?${URLparams.toString()}`, force);
    let parsed = JSON.parse(res);
    if((parsed.status && parsed.status !== "error" && parsed.status !== "error-no-internet") || parsed.status === "success"){
      if(parsed.data.length){
        setPageData(parsed.data);
        setLoading(false);


        let items = [];
        for (let i = 0; i < parsed.data.length; i++) {
          const element = parsed.data[i];
          items.push({
            "@type": "ListItem",
            "position": i+1,
            "item": {
              "@type": "Trip",
              "name": element.Tour_Name,
              "description": element.Tour_Desc,
              "url": "https://luxintrip.com" + `/${lan.filename}/tour/${element.Continent_Url}/${element.Country_Url}/${element.City_Url}/${element.Tour_Id}`,
              "itinerary": [
                {
                  "@type": "City",
                  "name": (lan.filename === "fa") ? element.City_Name : element.City_EnName,
                  "description": (lan.filename === "fa") ? element.City_Name : element.City_EnName,
                },
              ],
              "tripOrigin": {
                "@type": "Country",
                "name": (lan.filename === "fa") ? "ایران" : "Iran",
                "description": (lan.filename === "fa") ? "ایران" : "Iran",
              },
            }
          })
        }
        setReachDataType("ItemList", {
          "@type": "ItemList",
          "@id": "https://luxintrip.com" + location.pathname + "/#ItemList",
          "itemListElement": items,
        });
        return;
      }
    }
    setPageData([]);
    setLoading(false);
  }
  const makeItems = () => {
    if(loading){
      return (
          <LoadingFull/>
      )
    }
    if(!pageData.length){
      return (
        <div className='no-match'>
          {Dictionery.noToursFound[lan.filename]}
        </div>
      )
    }
    return pageData.map((v, i) => {
      if(window.innerWidth < 850){
        return (
          <TourCart v={v} i={i} key={i} lan={lan} big={true}/>
        )
      }
      return (
        <TourCartBig v={v} i={i} key={i} lan={lan} big={true}/>
      )
    })
  }

  return (
    <Styles>
      <TourFilter {...props} params={params} data={data}/>
      <div className='items'>
        {makeItems()}
      </div>
    </Styles>
  )
}

